import { useMemo } from 'react';

import { OrderLineStopType } from 'src/types/enums';
import { useTranslation } from '../../../../contexts/translation-context';

/** @deprecated Use useStopTypeItems() for translated stop type labels */
export const STOP_TYPE_ITEMS = [
  {
    key: OrderLineStopType.Load,
    name: 'Laden',
  },
  {
    key: OrderLineStopType.Unload,
    name: 'Lossen',
  },
];

export const useStopTypeItems = () => {
  const { i18n } = useTranslation();

  return useMemo(
    () => [
      {
        key: OrderLineStopType.Load,
        name: i18n('customerPortal.orders.load'),
      },
      {
        key: OrderLineStopType.Unload,
        name: i18n('customerPortal.orders.unload'),
      },
    ],
    [i18n],
  );
};
